import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { UserChooser } from '../statistics/UserChooser';
var styles = {
    textarea: {
        resize: 'none',
        height: '150px',
        width: '100%',
        padding: '5px',
        outline: 'none',
        border: '1px solid #ddd',
        fontSize: '13px',
        borderRadius: '5px',
        color: '#222'
    },
    label: {
        fontSize: '12px'
    },
    flex: {
        marginBottom: '20px',
        display: 'flex'
    }
};
var MessageDialog = /** @class */ (function (_super) {
    tslib_1.__extends(MessageDialog, _super);
    function MessageDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            user: null,
            message: ''
        };
        _this.handleTextChange = function (e) {
            e.preventDefault();
            _this.setState({ message: e.target.value });
        };
        _this.handleUserSelected = function (user) {
            _this.setState({ user: user });
        };
        _this.handleMessageSend = function () {
            var _a = _this.state, user = _a.user, message = _a.message;
            _this.props.onSendMessage(user, message);
        };
        _this.handleCancel = function (e) {
            e.preventDefault();
            _this.props.onCancel();
        };
        return _this;
    }
    MessageDialog.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isOpen !== nextProps.isOpen && !nextProps.isOpen) {
            this.setState({ user: null, message: '' });
        }
    };
    MessageDialog.prototype.render = function () {
        var _this = this;
        var isOpen = this.props.isOpen;
        var users = this.props.userStore.users
            .filter(function (i) { return i.id !== _this.props.userStore.userId; });
        var actions = [
            React.createElement(RaisedButton, { key: "K\u00DCLD\u00C9S", primary: true, label: "K\u00DCLD\u00C9S", onClick: this.handleMessageSend }),
            React.createElement(RaisedButton, { key: "M\u00C9GSE", style: { marginLeft: '15px' }, primary: false, label: "M\u00C9GSE", onClick: this.handleCancel })
        ];
        return (React.createElement(Dialog, { title: "\u00DAj \u00FCzenet", open: isOpen, modal: false, actions: actions },
            React.createElement("div", { className: "text-muted", style: styles.label }, "C\u00EDmzett"),
            React.createElement(UserChooser, { users: users, user: this.state.user, onSelection: this.handleUserSelected }),
            React.createElement("div", { className: "text-muted", style: styles.label }, "\u00DCzenet"),
            React.createElement("textarea", { value: this.state.message, style: styles.textarea, onChange: this.handleTextChange })));
    };
    MessageDialog = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], MessageDialog);
    return MessageDialog;
}(React.Component));
export { MessageDialog };



//////////////////
// WEBPACK FOOTER
// ./src/pages/messages/MessageDialog.tsx
// module id = 799
// module chunks = 0